import { getCurrencyConfigDict } from '@/helpers/currencyHelper';

export const getAssetName = (currency: string) => {
    const currencyConfigDict = getCurrencyConfigDict();
    return currencyConfigDict[currency] ? currencyConfigDict[currency].show : currency;
};

export const translatePair = (pair: string) => {
    if (pair.indexOf('/') > -1) {
        const [ccy1, ccy2] = pair.split('/');
        const ccy1Show = getAssetName(ccy1);
        const ccy2Show = getAssetName(ccy2);
        return `${ccy1Show}/${ccy2Show}`;
    } else {
        return pair;
    }
};
